import { render } from "./App.vue?vue&type=template&id=06b31506&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=06b31506&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=06b31506&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b31506"]])

export default __exports__